module.exports = __webpack_public_path__ + "img/901499253.cb98a6b4.png";